import type {RouteSync} from "vike/types";
import countryData from "../country.json";


export default ((pageContext) => {
  const urlPath = pageContext.urlPathname;
  const match = urlPath.match(/^\/clinic\/([^\/]+)$/);

  if (!match) {
    return false;
  }

  const slug = match[1];

  if (countryData[slug as keyof typeof countryData]) {
    return {routeParams: {country: slug}};
  }

  return false;
}) satisfies RouteSync;
